export default [
    {
        name: 'course-objectives-view',
        path: '/courses/:courseId/objectives/:objectiveId',
        component: () => import('@/pages/courses/objectives/Objective.vue'),
        props: true,
        meta: {
            title: 'Course Objectives',
            dataTablePage: true,
        },
    },
];
